import { Cache } from '@urql/exchange-graphcache';

import { GQGetMaterialVariantsQuery } from '../../generated/graphql-operations';
import { GetMaterialVariantsDocument } from '../../generated/urql';
import { invalidateAllTopLevelQueriesForNode } from '../cache';

export function updateMaterialVariantsRunProgressCache(
  cache: Cache,
  runningCount: number,
  runType: 'flash' | 'proxyMapping'
): void {
  cache.updateQuery(
    { query: GetMaterialVariantsDocument },
    (data: GQGetMaterialVariantsQuery | null) => {
      return updateMaterialVariantsRunProgress(data, runningCount, runType);
    }
  );
}

export function updateMaterialVariantsRunProgress(
  data: GQGetMaterialVariantsQuery | null,
  runningCount: number,
  runType: 'flash' | 'proxyMapping'
): GQGetMaterialVariantsQuery | null {
  if (!data) {
    return null;
  }

  // Create a deep copy to avoid mutating the original data
  const updatedData = JSON.parse(
    JSON.stringify(data)
  ) as GQGetMaterialVariantsQuery;

  updatedData.materialVariantsRunProgress.runningCount += runningCount;
  // When polling starts we will fetch the estimated time remaining from the server
  updatedData.materialVariantsRunProgress.estimatedTimeRemainingMinutes = null;

  if (runType === 'flash') {
    updatedData.productFootprintUsageAndLimits.flash.inProgressRuns +=
      runningCount;
  } else {
    updatedData.productFootprintUsageAndLimits.proxyMapping.inProgressRuns +=
      runningCount;
  }

  return updatedData;
}

/**
 * Invalidate material variant graphql nodes by lineage id.
 * This includes MaterialVariant and MaterialVariantWithPcf nodes.
 */
export function invalidateMaterialVariantNodesByLineageId(
  cache: Cache,
  targetLineageId: string
) {
  // Invalidate the relevant MaterialVariant cache entry.
  // MaterialVariant nodes are cached by lineage id, so the lineage id is the
  // normalized entity id used by graphcache.
  cache.invalidate({
    __typename: 'MaterialVariant',
    lineageId: targetLineageId,
  });

  // Invalidate the relevant MaterialVariantWithPcf cache entries
  // Since these rows are paginated, there is not as big a performance hit as
  // invalidating all material variants.
  invalidateAllTopLevelQueriesForNode(cache, 'materialVariantsWithPcfs');
}
